<template>
  <span class="file-label">{{ label }}</span>
</template>

<script>
  // A label as written in the file: inner spaces stay visible, since they are
  // what makes a code malformed.
  export default {
    name: 'FileLabel',
    props: {
      label: { type: String, required: true },
    },
  };
</script>

<style lang="scss" scoped>
  .file-label {
    font-family: monospace;
    white-space: pre;
  }
</style>
